module.exports = __webpack_public_path__ + "img/modal_succ.efb40f99.png";